import React, { createContext, useEffect, useReducer, useCallback } from "react";

import { titleCase, getParams, isEnquiry, rIC, sendAnalytics } from "../helper";

const initialState = (params = {}) => {
  const {
    date = "",
    first_name: firstName = "",
    last_name: lastName = "",
    time = "",
    num_people: numPeople,
    reference = "",
    status,
    type,
  } = params;

  let bookingTypeTitle = null;

  if (type) {
    const { name } = JSON.parse(type) || {};

    if (name) {
      bookingTypeTitle = name;
    }
  }

  return {
    apiEnabled: true,
    book: null,
    bookablePackages: null,
    bookingType: null,
    bookingTypeTitle,
    check: status ? { result: status } : null,
    comments: "",
    date,
    dob: "",
    email: "",
    errors: false,
    firstName,
    lastName,
    loading: false,
    numPeople,
    overrides: [],
    package: null,
    packages: null,
    phone: "",
    policy: false,
    promo: false,
    rules: {},
    step: reference.includes("DMN-") ? "confirmed" : "start",
    time,
    timeslots: [],
  };
};

const params = getParams(window.location.search);

const tableStore = createContext(initialState(params));
const { Provider } = tableStore;

const TableProvider = ({ children, venueId, endpoint, isActive, panelType }) => {
  const [state, dispatch] = useReducer((state, actions) => (!Array.isArray(actions) ? [actions] : actions).reduce((currentState, action) => {
    switch (action.type) {
      case "SET_API_ENABLED":
        return {
          ...currentState,
          apiEnabled: action.data
        };
      case "SET_BOOKING_TYPE":
        return {
          ...currentState,
          bookingType: action.data.id,
          bookingTypeTitle: action.data.title,
        };
      case "SET_PACKAGES":
        return {
          ...currentState,
          packages: action.data,
        };
      case "SET_BOOKABLE_PACKAGES":
        return {
          ...currentState,
          bookablePackages: action.data,
        };
      case "SET_DATE":
        return {
          ...currentState,
          date: action.data,
        };
      case "SET_TIME":
        return {
          ...currentState,
          time: action.data,
        };
      case "SET_GUESTS":
        return {
          ...currentState,
          numPeople: action.data,
        };
      case "SET_PACKAGE":
        return {
          ...currentState,
          package: action.data,
        };
      case "SET_EMAIL":
        return {
          ...currentState,
          email: action.data,
        };
      case "SET_PHONE":
        return {
          ...currentState,
          phone: action.data,
        };
      case "SET_FIRST_NAME":
        return {
          ...state,
          firstName: action.data,
        };
      case "SET_LAST_NAME":
        return {
          ...state,
          lastName: action.data,
        };
      case "SET_DOB":
        return {
          ...state,
          dob: action.data,
        };
      case "SET_PROMO":
        return {
          ...state,
          promo: action.data,
        };
      case "SET_POLICY":
        return {
          ...currentState,
          policy: action.data,
        };
      case "SET_COMMENTS":
        return {
          ...currentState,
          comments: action.data,
        };

      case "SET_ERROR":
        return {
          ...currentState,
          errors: action.data,
          loading: false,
        };
      case "SET_LOADING":
        return {
          ...currentState,
          errors: false,
          loading: true,
        };
      case "SET_CHECK":
        return {
          ...currentState,
          check: action.data,
          loading: false,
        };

      case "SET_BOOK":
        return {
          ...currentState,
          book: action.data,
          loading: false,
        };
      case "SET_STEP":
        return {
          ...currentState,
          step: action.data,
          loading: false,
        };
      case "SET_RULES":
        return {
          ...currentState,
          rules: action.data,
        };
      case "SET_MANDATORY_PACKAGES":
        return {
          ...currentState,
          packageMandatory: action.data,
        };
      case "RESET":
        return {
          ...initialState(),
        };
      case "SET_DURATION":
        return {
          ...currentState,
          duration: action.data,
        };
      case "SET_MAX_DURATION":
        return {
          ...currentState,
          maxDuration: action.data,
        };
      case "SET_MIN_DURATION":
        return {
          ...currentState,
          minDuration: action.data,
        };
      case "SET_TIMESLOTS":
        return {
          ...currentState,
          timeslots: action.data,
        };
      case "SET_END_TIMESLOTS":
        return {
          ...currentState,
          endTimeslots: action.data,
        };
      case "SET_OVERRIDES":
        return {
          ...currentState,
          overrides: action.data,
        };
      default:
        break;
    }

          return currentState;
        },
        state
      ),
    initialState(params)
  );

  const checkAvailability = () => {
    dispatch({ type: "SET_LOADING" });

    fetch(`${endpoint}/v1/venue/${venueId}/check`, {
      body: JSON.stringify({
        date: state.date,
        duration: state.duration,
        time: state.time,
        bookingType: state.bookingType,
        numPeople: state.numPeople,
        package: state.package,
      }),
      method: "POST",
    })
      .then((response) => response.json())
      .then((data) => {
        const errors = Array.from(
          Object.values(data._validationResults),
          (field) => {
            return field.errors;
          }
        )
          .filter(Boolean)
          .flat()
          .map((a) => a.message);

        if (errors.length) {
          [...new Set(errors)].forEach((e) => {
            sendAnalytics({
              hitType: "event",
              eventAction: "Get Availability",
              eventLabel: `Error - ${e}`,
            });
          });
          return dispatch({
            type: "SET_ERROR",
            data: [...new Set(errors)],
          });
        }

        return dispatch({
          type: "SET_CHECK",
          data,
        });
      });
  };

  const completeBooking = () => {
    dispatch({ type: "SET_LOADING" });

    fetch(`${endpoint}/v1/venue/${venueId}/book`, {
      body: JSON.stringify({
        date: state.date,
        time: state.time,
        bookingType: state.bookingType,
        numPeople: state.numPeople,
        package: state.package,
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        phone: state.phone,
        dob: state.dob,
        policy: state.policy,
        promo: state.promo,
        comments: state.comments,
        duration: state.duration,
      }),
      method: "POST",
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch({
          type: "SET_BOOK",
          data,
        });

        if (data?.error) {
          sendAnalytics({
            hitType: "event",
            eventAction: isEnquiry(state.check) ? "Enquire" : "Book",
            eventLabel: `Error - ${data.message}`,
          });

          return dispatch({
            type: "SET_ERROR",
            data: [data.message],
          });
        }

        if (data?.result === "confirmed" || data?.result === "received") {
          dispatch({
            type: "SET_STEP",
            data: "confirmed",
          });
        }
      });
  };

  const goToDetails = () => {
    return dispatch({
      type: "SET_STEP",
      data: "details",
    });
  };

  const reset = () => {
    return dispatch({ type: "RESET" });
  };

  useEffect(() => {
    if (["confirmed", "received"].includes(state?.check?.result)) {
      return undefined;
    }

    if (state?.check?.isValid === false) {
      return dispatch({
        type: "SET_STEP",
        data: "start",
      });
    }

    if (["accept", "enquire"].includes(state?.check?.result)) {
      if (state.packages) {
        const hoursUntilBooking =
          (Date.parse(`${state.date}`) - Date.now()) / 1000 / 60 / 60;

        const filteredPackages = Array.from(state.packages, (p) => {
          if (p.minimumNoticePeriod <= hoursUntilBooking) {
            return p;
          }
          return false;
        }).filter(Boolean);

        if (filteredPackages.length === 0) {
          return dispatch({
            type: "SET_STEP",
            data: "details",
          });
        }

        dispatch({
          type: "SET_BOOKABLE_PACKAGES",
          data: filteredPackages,
        });

        return dispatch({
          type: "SET_STEP",
          data: "packages",
        });
      }

      return dispatch({
        type: "SET_STEP",
        data: "details",
      });
    }

    if (state?.check?.result === "reject") {
      return dispatch({
        type: "SET_STEP",
        data: "alternate",
      });
    }

    if (state?.check?.result === "enquire") {
      return dispatch({
        type: "SET_STEP",
        data: "details",
      });
    }

    return dispatch({
      type: "SET_STEP",
      data: "start",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.check]);

  const sendAnalyticsData = useCallback(
    /** @param { { hitType: "pageview"; page: string; title: string } | { hitType: 'event'; eventAction: string; eventLabel?: string } } payload */
    (payload) => {
      if (!isActive) {
        // Initial step is `confirmed` when coming from DMN booking redirect
        // we want to log analytics
        if (state.step !== "confirmed") return;
      }

      rIC(() => {
        const data = { ...payload };

        if (data.hitType === "pageview") {
          data.page = `${titleCase(state.step)}/${data.page}`;
        }

        sendAnalytics(data);
      });
    },
    [isActive, state.step]
  );

  useEffect(() => {
    if (!isActive) return;
    sendAnalytics({
      hitType: "pageview",
      page: titleCase(state.step),
      title: state?.bookingTypeTitle || "Booking/Enquiry",
    });
  }, [isActive, state.step]);

  return (
    <Provider
      value={{
        isActive,
        panelType,
        table: state,
        tableDispatch: dispatch,
        setup: { venueId, endpoint },
        actions: {
          checkAvailability,
          goToDetails,
          completeBooking,
          reset,
          sendAnalyticsData,
        },
      }}
    >
      {children}
    </Provider>
  );
};

export { tableStore, TableProvider };
